/**
 * Pull the backend's `{ "error": "..." }` message out of a failed response so
 * the user sees the actionable Stripe error (e.g. "no attached payment source")
 * instead of a generic string. Falls back to a default when none is present.
 *
 * Lives in utils rather than a page so the Settings upgrade form and the
 * onboarding plan step surface identical wording for identical failures.
 */
export async function extractApiError(resp: Response, fallback: string): Promise<string> {
  try {
    const data = await resp.clone().json();
    if (data && typeof data.error === 'string' && data.error.trim()) return data.error;
  } catch {
    /* body was not JSON */
  }
  return fallback;
}
